import { render, staticRenderFns } from "./info_pc.vue?vue&type=template&id=b25ef48a&scoped=true&"
import script from "./info_pc.vue?vue&type=script&lang=js&"
export * from "./info_pc.vue?vue&type=script&lang=js&"
import style0 from "./info_pc.vue?vue&type=style&index=0&id=b25ef48a&lang=less&scoped=true&"
import style1 from "./info_pc.vue?vue&type=style&index=1&id=b25ef48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25ef48a",
  null
  
)

export default component.exports